async function openSaveAs(file) {
  const fileHandle = await window.showSaveFilePicker();
  const writable = await fileHandle.createWritable();
  await writable.write(file);
  await writable.close();
}

async function openFolderToSaveTo(files) {
  const directoryHandle = await window.showDirectoryPicker();
  directoryHandle.requestPermission({ writable: true })

  for (const file of files) {
    const fileHandle = await directoryHandle.getFileHandle(file.name, {create: true});
    const writable = await fileHandle.createWritable();
    await writable.write(file);
    await writable.close();
  }

 /* const fileHandle = await directoryHandle.getFile(file.name, {create: true});
  const writable = await fileHandle.createWritable();
  await writable.write(file.content);
  await writable.close();*/
  /*for await (let handle of directoryHandle.values()) {
    if (handle.type === "file") {
      // file
    }
    if (handle.type === "directory") {
      // subdirectory
    }
  }*/
}
